<template>
  <div class="progress">
    <div
      class="progress-bar progress-bar-erbe progress-bar-striped progress-bar-animated"
      role="progressbar"
      :style="{ width: 5 + (current / max) * 95 + '%' }"
      :aria-valuenow="current"
      aria-valuemin="0"
      :aria-valuemax="max"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    max: Number,
    current: Number
  }
};
</script>

<style>
.progress-bar-erbe {
  background-color: #7badaa !important;
}
.progress {
  margin-top: 10px;
}
</style>
